import React, { useState, useEffect, useContext } from "react";
import "popper.js";
import "bootstrap/dist/js/bootstrap";
import { useHistory } from 'react-router-dom';
// Componentes
import Foto from "../element/Foto";
import HeaderMenu from "../element/HeaderMenu";
import Menu from "./Menu";
// import FotoBiblio from "../element/FotoBiblio";
// Contexto
import dataContext from "../context/User";
// Helper
import GetFetch from "../helper/GetFetch";
import loadMenu from "../js/main";
import SkeletonCard from "../element/Skeleton";
import EmptyState from "../element/EmptyState";
import Footer from './Footer';

const BiblioCargosMoras = () => {
  const history = useHistory();
  const dataUser = useContext(dataContext);
  let datos = localStorage.getItem('dataUser');
  const [cargos, setCargos] = useState({});
  const [moras, setMoras] = useState(0);
  const [morasTitulos, setMorasTitulos] = useState();
  const [cargando, setCargando] = useState(true);

  useEffect(() => {

    if (datos) {
      let cred = JSON.parse(datos);
      dataUser.token = cred.token;
      dataUser.nombre = cred.nombre;
      dataUser.carnet = cred.carnet;

      let cargo = GetFetch.getCargosMorasBiblio(cred.carnet, cred.token)
      let mora = GetFetch.getMorasBiblio(cred.carnet, cred.token)
      let mt = GetFetch.getMorasTitulosBiblio(cred.carnet, cred.token)

      Promise.all([cargo, mora, mt])
      .then(values => {
        setCargos(values[0])
        setMoras(values[1][0].valor)
        setMorasTitulos(values[2])
        setCargando(false)
      }).catch(() => setCargando(false))

      loadMenu();
    } else {
      history.push("/");
    }
  }, [datos, history, dataUser]);

  let totalCargo = 0;
  if (cargos.length > 0) {
    cargos.map(el => {
      totalCargo += el.cargo_costo
      return null
    })
  }

  const hayMorasTitulos = morasTitulos && morasTitulos.length > 0;
  const hayCargos = cargos.length > 0;
  const hayDatos = hayMorasTitulos || hayCargos || +moras > 0;

  return (
    // <div>

    <div className="wrapper d-flex align-items-stretch">
      <nav id="sidebar">
        <div className="custom-menu">
          <button
            type="button"
            id="sidebarCollapse"
            className="btn btn-primary"
          >
            <i className="fa fa-bars"></i>
            <span className="sr-only">Toggle Menu</span>
          </button>
        </div>
        <div className="p-4">
          <Foto foto={dataUser.carnet} alt="Foto alumno" tamanio="rounded" />

          <HeaderMenu
            carnet={dataUser.carnet}
            nombre={dataUser.nombre}
            posicion="text-center"
          />

          <Menu />

          <Footer />
        </div>
      </nav>

      <div id="content" className="p-4 p-md-5 pt-5">
        <h2 className="mb-4">Cargos y moras CCESEN</h2>

        {cargando ? (
          <>
            <div className="esen-stat-grid">
              <SkeletonCard rows={1} title={false} />
              <SkeletonCard rows={1} title={false} />
            </div>
            <SkeletonCard rows={4} />
          </>
        ) : hayDatos ? (
          <>
            <div className="esen-stat-grid">
              <div id="totalCargoMora" className="esen-stat esen-stat--hero">
                <div>
                  <div className="esen-stat-value">${+totalCargo + +moras}</div>
                  <div className="esen-stat-label">Total de mora + cargos</div>
                </div>
              </div>
              <div className="esen-stat">
                <div>
                  <div className="esen-stat-value">${moras}</div>
                  <div className="esen-stat-label">Mora</div>
                </div>
              </div>
              <div id="co" className="esen-stat">
                <div>
                  <div className="esen-stat-value">${totalCargo}</div>
                  <div className="esen-stat-label">Cargos</div>
                </div>
              </div>
            </div>

            {hayMorasTitulos ? (
              <div className="card mb-4">
                <div className="card-body">
                  <h3 className="h5 mb-3">
                    <i className="fa fa-clock-o mr-2" aria-hidden="true"></i>
                    Títulos con mora
                  </h3>
                  <div className="table-responsive">
                    <table className="table">
                      <thead>
                        <tr>
                          <th scope="col">Título</th>
                          <th scope="col">Fecha del préstamo</th>
                          <th scope="col">Fecha de la devolución</th>
                          <th scope="col">Fecha real de devolución</th>
                        </tr>
                      </thead>
                      <tbody>
                        {morasTitulos.map(element => {
                          let prestamoFecha = new Date(element.dateadd);
                          let devolucionFecha = new Date(element.datedev);
                          let realDevolucionFecha = new Date(element.fechadevolucion);
                          return (
                            <tr key={element.dateadd}>
                              <td><b>{element.titulos}</b></td>
                              <td>{prestamoFecha.toLocaleString()}</td>
                              <td>{devolucionFecha.toLocaleString()}</td>
                              <td>
                                <span className="esen-chip esen-chip--warning">
                                  <i className="fa fa-calendar" aria-hidden="true"></i>
                                  {realDevolucionFecha.toLocaleString()}
                                </span>
                              </td>
                            </tr>
                          )
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            ) : null}

            {hayCargos ? (
              <div className="card">
                <div className="card-body">
                  <h3 className="h5 mb-3">
                    <i className="fa fa-file-text-o mr-2" aria-hidden="true"></i>
                    Detalle de cargos
                  </h3>
                  <div className="table-responsive">
                    <table className="table">
                      <thead>
                        <tr>
                          <th scope="col">Descripción</th>
                          <th scope="col">Fecha del cargo</th>
                          <th scope="col">Tipo</th>
                          <th scope="col">Cargo</th>
                        </tr>
                      </thead>
                      <tbody>
                        {cargos.map(element => {
                          let fecha = new Date(element.cargo_fecha);
                          return (
                            <tr key={element.cargo_id}>
                              <td><b>{element.cargo_desc}</b></td>
                              <td>{fecha.toLocaleString()}</td>
                              <td>
                                <span className="esen-chip esen-chip--info">
                                  {element.cargos_tipo_desc}
                                </span>
                              </td>
                              <td>${element.cargo_costo}</td>
                            </tr>
                          )
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            ) : null}
          </>
        ) : (
          <EmptyState icon="fa-check-circle" title="Estás al día con el CCESEN">
            No tienes cargos ni moras pendientes con la biblioteca.
          </EmptyState>
        )}
      </div>
    </div>
  );
};

export default BiblioCargosMoras;
